<template>
  <div>
    <PageTitle
      title="Dish View"
      :backBtn="true"
      :editRoute="'/dishes/edit/' + this.$route.params.id"
      :permission="'User Edit'"
    />
    <v-container fluid>
      <!-- Page Title -->
    
      <v-row>
        <v-col cols="12" sm="12" md="4" lg="4">
          <v-card>
            <v-img v-if="Dish.image"    :src="Dish.image" height="500"> </v-img>

                  <v-img v-else src="../../../assets/food.jpg" height="500"> </v-img>
            <v-list two-line class="pl-10 pr-10">
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-id-card</v-icon>
                </v-list-item-action>
                <v-row>
                <v-list-item-content>
                  <v-col>
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Dish Name</v-list-item-title
                  >
                  </v-col>
                  <v-col>
                  <v-list-item-title>{{ Dish.name }} </v-list-item-title>
                  </v-col>
                </v-list-item-content>
                </v-row>
              </v-list-item>

              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-id-card</v-icon>
                </v-list-item-action>
                <v-row>
                <v-list-item-content>
                  <v-col>
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Code</v-list-item-title
                  >
                  </v-col>
                  <v-col>
                  <v-list-item-title>{{ Dish.code }} </v-list-item-title>
                  </v-col>
                </v-list-item-content>
                </v-row>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-av-timer</v-icon>
                </v-list-item-action>
                <v-row>
                <v-list-item-content>
                  <v-col>
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Average Cooking Time</v-list-item-title
                  >
                  </v-col>
                  <v-col>
                  <v-list-item-title>{{
                    Dish.avrage_gooking_time
                  }}</v-list-item-title>
                  </v-col>
                </v-list-item-content>
                </v-row>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-food</v-icon>
                </v-list-item-action>
                <v-row>
                <v-list-item-content>
                  <v-col>
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Is Ready Made</v-list-item-title
                  >
                  </v-col>
                  <v-col>
                  <v-list-item-title>
                    {{ Dish.is_ready_made }}</v-list-item-title
                  >
                  </v-col>
                </v-list-item-content>
                </v-row>
              </v-list-item>

              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-food</v-icon>
                </v-list-item-action>
                <v-row>
                <v-list-item-content>
                  <v-col>
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Category</v-list-item-title
                  >
                  </v-col>
                  <v-col>
                  <v-list-item-title> {{ Dish.categories[0].name }}</v-list-item-title>
                  </v-col>
                </v-list-item-content>
                </v-row>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col cols="12" sm="12" md="8" lg="8">
          <v-card class="mb-15">
            <v-card-title>Dish Types</v-card-title>
            <Types :selectedTypeData="Dish.types" />
          </v-card>

 <v-card class="address-card">
            <v-card-title> Dish Ingredients</v-card-title>
            <Ingredients :selectedIngredientsData="Dish.ingredients" />
          </v-card>


        </v-col>

      
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { required, email, max, regex } from "vee-validate/dist/rules";

import Types from "./DishType/DishTypesDetails";
import Ingredients from "./DIshIngredient/DishIngredientSDetails";
import { Dishes } from "../../../models/Dishes";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Types,
    Ingredients,
  },
  data: () => ({
    Dish: new Dishes(),
    messages: [],
  }),

  methods: {
    GetSingleDishDetails() {
      let DishId = this.$route.params.id;
      this.$store
        .dispatch("dish/GetSingleDish", DishId)
        .then((res) => {
          this.Dish = new Dishes().toView(res.data);
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
  },
  created() {
    this.GetSingleDishDetails();
  },
};
</script>
